import * as Sentry from '@sentry/react';
import { getFirebaseEnvConfig } from './firebase/utilities';
import { ApolloLink } from '@apollo/client';
export const initSentry = async () => {
  const firebaseEnvConfig = await getFirebaseEnvConfig();

  Sentry.init({
    dsn: firebaseEnvConfig?.sentryDSN,
    release: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_ENVIRONMENT,

    sendDefaultPii: true,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
      }),
    ],

    enabled: window.location.hostname !== 'localhost',

    ignoreErrors: [
      'Missing "data" field with no errors in response from remote',
      // eslint-disable-next-line @typescript-eslint/quotes
      "Cannot read properties of undefined (reading 'data')",
      'Missing "data" field',
    ],
  });
};

export const sentryBreadcrumbLink = new ApolloLink((operation, forward) => {
  Sentry.addBreadcrumb({
    type: 'http',
    category: 'graphql',
    message: `GraphQL: ${operation.operationName}`,
    level: 'info',
    data: {
      variables: operation.variables,
    },
  });

  return forward(operation);
});
